import React, { useState } from 'react';
import PrinterForm from '../../components/PrinterForm';
import message from '~/utils/message';
import { createPrinter } from './api';
import { PrinterItem } from '../../types';
import { useNavigate } from 'react-router-dom';

const CreatePrinter = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (values: PrinterItem) => {
    if (loading) return;

    setLoading(true);
    try {
      await createPrinter(values);
      message.success('Success create printer');
      navigate('..');
    } catch (e: any) {
      message.error(`Fail to create printer: ${e.message}`);
    }
    setLoading(false);
  };

  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl">Create Printer</h1>
      </div>
      <div className="max-w-[800px]">
        <PrinterForm loading={loading} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default CreatePrinter;
